import type { AppLanguage } from '../i18n/types';
import type { MessageKey } from '../i18n/messages';
import { assetRecordDisplayTitle } from '../components/AssetGetByIdView';
import {
  formatDistanceFromKm,
  parseAssetCoordinates,
  type GeoCoordinates,
} from '../utils/assetGeo';
import { sortAssetBrowseListRecords } from '../utils/assetBrowseListSort';
import { assetDistanceKm } from '../utils/homeAssetRanking';

type TranslateFn = (key: MessageKey, params?: Record<string, string | number>) => string;

/** Sort current rows by distance to an anchor (e.g. a geocoded street). */
export function sortAssetsByProximityAnchor(
  rows: Record<string, unknown>[],
  anchor: GeoCoordinates,
  language: AppLanguage,
): Record<string, unknown>[] {
  return sortAssetBrowseListRecords(rows, 'distance', { viewer: anchor, language });
}

/** “The closest is X — 1.2 km from חיל הנדסה.” */
export function assistantProximityReply(
  rows: Record<string, unknown>[],
  anchor: GeoCoordinates,
  streetLabel: string,
  t: TranslateFn,
  language: AppLanguage,
): { text: string; sorted: Record<string, unknown>[] } {
  const sorted = sortAssetsByProximityAnchor(rows, anchor, language);
  const top = sorted.find((row) => parseAssetCoordinates(row));
  if (!top) {
    return { text: t('assistant.result.proximityNoGeo'), sorted };
  }
  const km = assetDistanceKm(top, anchor);
  const distance =
    km == null ? '' : formatDistanceFromKm(km, language === 'he' ? 'he' : 'en');
  return {
    text: t('assistant.result.closestToStreet', {
      name: assetRecordDisplayTitle(top),
      street: streetLabel,
      distance: distance || (language === 'he' ? 'בקרבת מקום' : 'nearby'),
    }),
    sorted,
  };
}
